export var EntityType;
(function (EntityType) {
    EntityType["Task"] = "task";
    EntityType["AttachmentReference"] = "attachmentReference";
})(EntityType || (EntityType = {}));
//# sourceMappingURL=entity.js.map